    (function($) {

    var wow = new WOW({});
    wow.init();



  $(window).on('scroll',function(){
    var scrollTop = $(this).scrollTop();

    if(scrollTop >= 150  && !$('header.header>.header-inner').hasClass('scrolled-header')) {
      $('header.header>.header-inner').addClass('scrolled-header');
            $('img.main-logo.custom-logo').fadeOut(500,function(){
                $('img.scroll-logo.custom-logo').fadeIn(200);
            });
    }

    else if(scrollTop <= 149 && $('header.header>.header-inner').hasClass('scrolled-header')) {
      $('header.header>.header-inner').removeClass('scrolled-header');
            $('img.scroll-logo.custom-logo').fadeOut(500,function(){
                $('img.main-logo.custom-logo').fadeIn(200);
            });
    }
  });

// Function to equalize heights for all slides in a slider
function setSliderSlideHeights($slider) {
  var maxHeight = 0;
  $slider.find('.slick-slide').css('height', 'auto'); // Reset heights
  $slider.find('.slick-slide').each(function(){
    var thisHeight = $(this).outerHeight();
    if (thisHeight > maxHeight) {
      maxHeight = thisHeight;
    }
  });
  $slider.find('.slick-slide').css('height', maxHeight + 'px');
}

// Generic function to initialize a slider with shared options and height logic
function initCustomSlider(selector, options) {
  var $slider = $(selector);

  $slider.on('init', function(event, slick){
    setSliderSlideHeights($slider);
  });

  $slider.on('setPosition', function(event, slick){
    setSliderSlideHeights($slider);
  });

  $(window).on('resize', function(){
    setSliderSlideHeights($slider);
  });

  $slider.slick(options);
}

$(document).ready(function(){

    initCustomSlider('.case-studies-slider', {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.case-studies-arrows .arrow-btn.prev'),
      nextArrow: $('.case-studies-arrows .arrow-btn.next'),
      appendArrows: $('.case-studies-arrows'),
      dots: true,
      appendDots: $('.case-studies-dots'),
      infinite: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    });

    initCustomSlider('.innovation-centres-slider', {
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      prevArrow: $('.innovation-arrows .arrow-btn.prev'),
      nextArrow: $('.innovation-arrows .arrow-btn.next'),
      appendArrows: $('.innovation-arrows'),
      dots: true,
      appendDots: $('.innovation-dots'),
      infinite: false,
      responsive: [
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        }
      ]
    });

  var $slider = $('.testimonials-slider');
  var singleSlide = $slider.hasClass('single-slide');

  initCustomSlider('.testimonials-slider', {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: !singleSlide,
    prevArrow: $('.test-arrows .arrow-btn.prev'),
    nextArrow: $('.test-arrows .arrow-btn.next'),
    appendArrows: $('.test-arrows'),
    dots: !singleSlide,
    adaptiveHeight: true,
    appendDots: $('.test-dots'),
    centerMode: true,
    centerPadding: '100px',
    infinite: false,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          centerMode: false
        }
      }
    ]
  });

  // Optionally, ensure arrows/dots containers are hidden if only one slide
  if(singleSlide) {
    $('.test-arrows').hide();
    $('.test-dots').hide();
  }





      $('.projects-preview-slider').slick({
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        autoplay: true,
        //appendArrows: $('.projects-preview-arrows'),
        fade: true,
            pauseOnFocus: false,
            pauseOnHover: false,
      });

       $('.partner-logos-slider').slick({
        infinite: true,
        arrows: false,
        slidesToShow: 3,
        autoplay: true,
            autoplaySpeed: 0,
            speed: 2000,
        dots: false,
       responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            centerMode: true,
          }
        },

             {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              }
            },
        ],
      });

        $('.posts-slider').slick({
            infinite: false,
            arrows: true,
            slidesToShow: 4,
            autoplay: true,
            dots: true,
            appendArrows: $('#posts-arrow-container'),
           responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '20px',
              }
            },
            ],
          });
         var contents_slider = function($selector, $slides) {

        var slider = $($selector).find('.contents-slider'),
            slider_prev = $($selector).find('.content-prev'),
            slider_next = $($selector).find('.content-next');

         $(slider).slick({
            infinite: false,
            arrows: true,
            slidesToShow: $slides,
            autoplay: true,
            dots: false,
            prevArrow: slider_prev,
            nextArrow: slider_next,
           responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: $slides,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '20px',
              }
            },
            ],
          });
        }

        $('.contents-slider-outer').each(function(){
            contents_slider(this, 2);
        });

        contents_slider('.testimonials-section',1);
        contents_slider('.contents-slider-outer-letters',3);

    

    var windowWidth = $(window).width();

        if(windowWidth > 1170) {
            var centerPadAmount = (windowWidth - 1170) / 2;
        }

        else {
            var centerPadAmount = 20;
        }

  });

//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});

$(document).bind('keydown', function(e) {
  //alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});


    $(window).on('load',function() {        
        // Animate loader off screen
        $("#loader").fadeOut(200);
    });

//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
});

    var resizeItem = function($selector) {
        var itemSize = 0;

        $($selector).each(function(i){
                if($(this).innerHeight() > itemSize) {
                    itemSize = $(this).innerHeight();
                }
        })

        $($selector).css('height',itemSize + 'px');
           
        };

    $(window).on('load',function(){
        //resizeItem('.page-link-contents');
        resizeItem('.post-type-archive-case-study h3.slider-title');
    });

    $('#tm-filters button').on('click',function(event){
        var dataTarget = $(this).data('tm-target');

         $('#tm-filters button').removeClass('active-filter');
         $(this).addClass('active-filter');

        $('.tm-with-filters').hide();
            $(dataTarget).each(function(){
                $(this).fadeIn(300);
            })
        });

       
            var timelineItems =  $('.timeline-outer .timeline-inner .timeline-item'),
                timelineOffset = 0,
                timelineSingle = 0;


            $(window).on('load resize', function(e){
                    timelineOffset = 0;
                    timelineSingle = 0;
                    $(timelineItems).each(function(i){
                    timelineSingle = $(this).innerWidth();
                    timelineOffset = timelineOffset + timelineSingle;
                    $(this).data('timeline-offset',timelineOffset);
                });
            });
        

        var updateTimeline = function($input) {
            if($input.length > 0) {
            var thisOffset = ($($input).data('timeline-offset') - ($('.timeline-outer').innerWidth() - timelineSingle) / 2) - timelineSingle,
                vpWidth = $(window).width() / 2,
                offset = vpWidth - thisOffset,
                setYear = $($input).data('tl-year'),
                setData = $($input).data('tl-info');

            $('.timeline-inner').animate( { scrollLeft: thisOffset }, 1000);
            $(timelineItems).removeClass('active-year');
            $($input).addClass('active-year');

            var tlscroll = $('.timeline-inner').scrollLeft();

            $('.timeline-info').fadeOut(300,function(){
                console.log(tlscroll);
                $('.tl-year').html(setYear);
                $('.tl-info').html(setData);
                $('.timeline-info').fadeIn(300);

            });
            }
        }

        $(timelineItems).on('click',function(){
            updateTimeline($(this));
        });

        $('.tl-previous').on('click',function(){
            var previousTL = $('.timeline-item.active-year').prev();
            updateTimeline(previousTL);
        });

        $('.tl-next').on('click',function(){
            var nextTL = $('.timeline-item.active-year').next();
            updateTimeline(nextTL);
        });

        $(document).foundation();

        $(document).on('hide.zf.dropdown', function(e) {
          const $pane = $(e.target);
          $pane.one('transitionend', () => $pane.css('display', 'none'));
          $pane.css('display', 'block'); // keep visible while animating
        });

        $(window).on('load resize', function(){
            var headerInner = $('.header-inner').innerHeight();

            $('.content').css('padding-top', headerInner + 'px'); 
        });

document.addEventListener("DOMContentLoaded", function () {
  const offerings = document.querySelectorAll(".single-offering");
  const contentOuter = document.querySelector(".offering-content-outer");
  const allContent = document.querySelectorAll(
    ".offering-content-outer .offering-inner-content, .single-offering + .offering-inner-content"
  );

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function setupLayout() {
    if (isMobile()) {
      // move each content block under its single-offering
      offerings.forEach(offering => {
        const targetSelector = offering.getAttribute("data-tab-target");
        const target = document.querySelector(targetSelector);
        if (target && target.parentNode !== offering.parentNode) {
          offering.insertAdjacentElement("afterend", target);
        }
      });
    } else {
      // move all content blocks back into contentOuter
      allContent.forEach(c => {
        if (c.parentNode !== contentOuter) {
          contentOuter.appendChild(c);
        }
      });
    }
  }

  // run once on load
  setupLayout();

  // re-run on resize
  window.addEventListener("resize", setupLayout);

  offerings.forEach(offering => {
    offering.addEventListener("click", function () {
      const targetSelector = this.getAttribute("data-tab-target");
      const target = document.querySelector(targetSelector);
      if (!target) return;

      if (isMobile()) {
        // accordion behaviour
        const isActive = this.classList.contains("active-offering");
        offerings.forEach(o => o.classList.remove("active-offering"));
        allContent.forEach(c => c.classList.remove("active-offering-content"));

        if (!isActive) {
          this.classList.add("active-offering");
          target.classList.add("active-offering-content");
        }
      } else {
        // desktop tab behaviour
        offerings.forEach(o => o.classList.remove("active-offering"));
        this.classList.add("active-offering");

        allContent.forEach(c =>
          c.classList.remove("active-offering-content")
        );
        target.classList.add("active-offering-content");
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', function() {
  // Get all play buttons
  const playButtons = document.querySelectorAll('.play-btn');

  playButtons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      const popupSelector = btn.getAttribute('data-popup');
      const videoUrl = btn.getAttribute('data-video');
      const popup = document.querySelector(popupSelector);
      const iframe = popup.querySelector('.youtubeFrame');
      // Set the src to the video URL
      iframe.src = videoUrl;
      popup.style.display = 'flex';
    });
  });

  // Get all popups and their close buttons
  const popups = document.querySelectorAll('.video-popup');
  popups.forEach(function(popup) {
    const closeBtn = popup.querySelector('.closePopup');
    const iframe = popup.querySelector('.youtubeFrame');
    // Hide popup on close button click
    closeBtn.addEventListener('click', function() {
      popup.style.display = 'none';
      iframe.src = ""; // Stop video
    });
    // Optional: Hide popup when clicking outside the video box
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        popup.style.display = 'none';
        iframe.src = ""; // Stop video
      }
    });
  });
});


})( jQuery );

(function(){
  'use strict';

  // Default selectors — override by calling HeaderPaddingSync({ headerSelector, contentSelector })
  var DEFAULTS = {
    headerSelector: '.header',
    contentSelector: '.offcanvas-content > .content'
  };

  function getHeaderHeight(header){
    if (!header) return 0;
    // Use bounding rect height to include transforms / subpixel heights
    return header.getBoundingClientRect().height || 0;
  }

  function applyPadding(height, elements){
    elements.forEach(function(el){
      // read computed style to avoid clobbering other inline styles unnecessarily
      // but we set inline paddingTop so it takes precedence over CSS
      var computed = window.getComputedStyle(el).paddingTop || '0px';
      var current = parseFloat(computed) || 0;
      // only apply if meaningfully different (avoid layout churn)
      if (Math.abs(current - height) > 0.5) {
        el.style.paddingTop = Math.ceil(height) + 'px';
      }
    });
  }

  // Create and return a controller with destroy/update methods
  function HeaderPaddingSync(options){
    options = Object.assign({}, DEFAULTS, options || {});

    var header = document.querySelector(options.headerSelector);
    if (!header) {
      // No header — nothing to do
      // Fail silently (but log to console for debugging)
      if (typeof console !== 'undefined') {
        console.warn('[HeaderPaddingSync] header not found for selector:', options.headerSelector);
      }
      return {
        destroy: function(){},
        update: function(){}
      };
    }

    // Keep elements in an array we can update if new elements are inserted
    var contents = Array.from(document.querySelectorAll(options.contentSelector));
    var lastHeight = null;
    var rafId = null;

    function updateNow(){
      rafId = null;
      var h = Math.ceil(getHeaderHeight(header));
      if (h !== lastHeight) {
        applyPadding(h, contents);
        lastHeight = h;
      }
    }

    function scheduleUpdate(){
      if (rafId == null) rafId = requestAnimationFrame(updateNow);
    }

    // ResizeObserver to detect header height changes (preferred)
    var ro;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(scheduleUpdate);
      ro.observe(header);
    } else {
      // fallback
      window.addEventListener('resize', scheduleUpdate, { passive: true });
    }

    // MutationObserver to detect class/style/child changes that could affect header height
    var mo = new MutationObserver(scheduleUpdate);
    mo.observe(header, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true });

    // Observe document for added/removed content elements matching the selector
    var contentObserver = new MutationObserver(function(){
      var nodes = Array.from(document.querySelectorAll(options.contentSelector));
      // replace contents array content (preserve reference)
      contents.length = 0;
      nodes.forEach(function(n){ contents.push(n); });
      scheduleUpdate();
    });
    contentObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });

    // initial measurement
    scheduleUpdate();

    return {
      destroy: function(){
        if (ro) ro.disconnect();
        mo.disconnect();
        contentObserver.disconnect();
        if (!window.ResizeObserver) window.removeEventListener('resize', scheduleUpdate);
        if (rafId != null) cancelAnimationFrame(rafId);
      },
      update: updateNow
    };
  }

  // Expose factory on window and auto-init
  window.HeaderPaddingSync = HeaderPaddingSync;

  // Auto-init on DOMContentLoaded (stores instance at window._headerPaddingInstance)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      try { window._headerPaddingInstance = HeaderPaddingSync(); } catch(e){ console.error(e); }
    });
  } else {
    try { window._headerPaddingInstance = HeaderPaddingSync(); } catch(e){ console.error(e); }
  }
})();